module.exports = __webpack_public_path__ + "img/line-chart-stepped-light-01.3c66bbeb.jpg";